﻿import React, { useState,  useEffect } from 'react';
import { Link } from "react-router-dom";

import { ActiveStatus } from 'components/status';
import { ArrayToEllipsesString } from 'components/formatting';
import { LinkButton } from 'components/buttons'
import { ListingTable } from "components/listing";
import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess, UserHasAccess } from 'components/user-access';

import { EmployeeService } from 'services';

import moment from "moment";
import { useDocumentSettings } from 'pages/documents/settings/shared';
import { PoliciesLayout } from 'pages/policy';

export function PolicyListing(props) {

    const { defaultPath } = useDocumentSettings();

    const defaultRecordSize = 25;

    const [totalRecords, setTotalRecords] = useState(0);
    const [tableRows, setTableRows] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(defaultRecordSize);
    const [loadingData, setLoadingData] = useState(true);
    const noDataMessage = "You have no policies, please click 'Add new policy' to get started.";
    const tableHeaders = ["Status", "Name", "No. of Docs", "Active From", "End Date", "Driver Types", "Driver Categories", "Locations"];
    const sortableHeaders = ["Status", "Name", "Active From", "End Date"];
    const [tableSortBy, setTableSortBy] = useState("Name");
    const [tableSortDir, setTableSortDir] = useState("A");
    const requiredAction = "Documents:Manage";
    const canAccessPage = UserHasAccess(requiredAction);
    const isInternal = UserHasAccess("Internal");    
    
    useEffect(() => {
        if (loadingData && canAccessPage) {

            EmployeeService.getPolicies(pageSize, pageNumber, tableSortBy, tableSortDir).then(r => {

                let results = r.data;
                let data = [];

                if (results != null) {
                    data = results.map((d) => {
                        
                        var docCount = d.policyDocuments.length;

                        var driverCats = d.employeeCategorys.map(b => {
                            return b.name
                        });
                                                
                        var drStatus = d.employeeTypes.map(t => {
                            return t.name
                        });

                        var locations = getLocations(d);

                        var endDateStr = 'not set';
                        if (d.endDate) {
                            endDateStr = moment(d.endDate).format('DD/MM/YYYY');
                        }

                        return [
                            <ActiveStatus key={`active-status-${d.policyId}`} isActive={d.active} />,
                            <Link key={`link-${d.policyId}`} to={`/policy-management/policies/${d.policyId}`}>{d.name}</Link>,
                            docCount, moment(d.startDate).format('DD/MM/YYYY'),
                            endDateStr, drStatus.join(', '),
                            <ArrayToEllipsesString key={`driver-cats-${d.policyId}`}>{driverCats}</ArrayToEllipsesString>,
                            <ArrayToEllipsesString key={`locations-${d.policyId}`}>{locations}</ArrayToEllipsesString>
                        ];
                    })
                }

                setTableRows(data);
                setTotalRecords(r.totalCount);
                setLoadingData(false);

            });
        }
    
    }, [loadingData, pageSize, pageNumber, tableSortBy, tableSortDir]);

    function onPagingChange(newPageNumber, newPageSize) {
        setPageNumber(newPageNumber);
        setPageSize(newPageSize);
        setLoadingData(true);
    }
       

    function onTableSort(header, direction) {
        setTableSortBy(header);
        setTableSortDir(direction);
        setLoadingData(true);
    }

    function getLocations(policy) {
        var locations = [];
        if (!policy.useAllLocations) {            
            locations = policy.locationNames;
        } else {
            locations.push('All Locations');
        }
        return locations;
    }

    return (

        <UserAccess perform={requiredAction}
            yes={() => (
                <PoliciesLayout breadcrumbs={props.breadcrumbs} defaultPath={defaultPath}>
                    <div className='button-row spacer-bottom'>
                        <LinkButton intent="primary" text="Add new policy" href="/policy-management/policies/create" id="new-policy" />
                        {isInternal && <LinkButton intent="primary" text="Upload Documents" href="/policy-management/policies/upload-document" id="upload-document" />}
                    </div>
                    <ListingTable
                        id="listing-table-policies"
                        headers={tableHeaders}
                        data={tableRows}
                        totalRecordCount={totalRecords}
                        onPagingChange={onPagingChange}
                        loadingData={loadingData}
                        noDataMessage={noDataMessage}
                        sortable
                        sortableHeaders={sortableHeaders}
                        sortedBy={tableSortBy}
                        sortedDir={tableSortDir}
                        onSort={onTableSort}
                    />
                </PoliciesLayout>
            )}
            no={() => (
                <PageRestricted />
            )}
        />

        

    );

}